angular
  .module('app')
  .controller('mainCtrl', [
    '$scope',
    'authService',
    'settingsService',
    mainController,
  ])

function mainController($scope, authService, settingsService) {
  $scope.isAuth = false

  $scope.logout = function () {
    authService.logout()
  }
  $scope.settings = function () {
    settingsService.open()
  }
  $scope.checkAuth = function () {
    if (!authService.validateAccessByToken()) {
      // Token expired — try silent refresh before sending user to login.
      authService.refreshToken().then(
        function () {
          $scope.isAuth = true
        },
        function () {
          window.location.href = '/login/index.html'
        }
      )
    } else {
      $scope.isAuth = true
    }
  }

  $scope.checkAuth()

  $scope.version = ''
}
